import apiService from './apiService'

export default {
  // Connexion utilisateur
  async login(credentials) {
    try {
      const response = await apiService.post('/auth/login', {
        username: credentials.username,
        password: credentials.password
      })
      
      // Sauvegarder le token si la connexion réussit
      if (response.data && response.data.access_token) {
        localStorage.setItem('token', response.data.access_token)
        localStorage.setItem('user', JSON.stringify(response.data.user))
        return {
          success: true,
          message: response.message || 'Connexion réussie',
          user: response.data.user,
          token: response.data.access_token
        }
      } else {
        // Échec de connexion - pas de token
        return {
          success: false,
          message: response.message || 'Échec de la connexion'
        }
      }
    } catch (error) {
      console.error('Login error:', error)
      
      // Gérer les différents types d'erreurs
      if (error.response) {
        const status = error.response.status
        const data = error.response.data
        
        if (status === 401) {
          return {
            success: false,
            message: 'Nom d\'utilisateur ou mot de passe incorrect'
          }
        } else if (status === 422) {
          return {
            success: false,
            message: data.message || 'Données de connexion invalides'
          }
        } else if (status >= 500) {
          return {
            success: false,
            message: 'Erreur du serveur. Veuillez réessayer plus tard.'
          }
        } else {
          return {
            success: false,
            message: data.message || 'Erreur de connexion'
          }
        }
      } else if (error.request) {
        return {
          success: false,
          message: 'Impossible de contacter le serveur. Vérifiez votre connexion.'
        }
      } else {
        return {
          success: false,
          message: 'Une erreur inattendue s\'est produite'
        }
      }
    }
  },

  // Déconnexion
  async logout() {
    try {
      await apiService.post('/auth/logout')
    } catch (error) {
      console.error('Logout error:', error)
    } finally {
      // Nettoyer le localStorage
      localStorage.removeItem('token')
      localStorage.removeItem('user')
    }
  },

  // Vérifier si l'utilisateur est connecté
  isAuthenticated() {
    return !!localStorage.getItem('token')
  },

  // Obtenir les informations de l'utilisateur
  getUser() {
    const user = localStorage.getItem('user')
    return user ? JSON.parse(user) : null
  },

  // Rafraîchir le token
  async refreshToken() {
    try {
      const response = await apiService.post('/auth/refresh')
      if (response.data && response.data.access_token) {
        localStorage.setItem('token', response.data.access_token)
      }
      return response
    } catch (error) {
      console.error('Token refresh error:', error)
      throw error
    }
  },

  // Inscription (si nécessaire)
  async register(userData) {
    try {
      const response = await apiService.post('/auth/register', userData)
      
      if (response.data && response.data.access_token) {
        localStorage.setItem('token', response.data.access_token)
        localStorage.setItem('user', JSON.stringify(response.data.user))
      }
      
      return response
    } catch (error) {
      console.error('Register error:', error)
      throw error
    }
  }
} 